import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=a9306c5e&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=a9306c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9306c5e",
  null
  
)

export default component.exports